import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgAppListHeaderService, IMetricsTopExecutions } from "../ng-app-list-header.service";
import { INgBarGraphValue } from "../../../ng-shared/ng-components/ng-bar-graph/ng-bar-graph.component";
import { getAppDetailsRoute, displayBigNumber } from "../../../ng-shared/ng-util/tools";
import { Subscription } from "rxjs";
import * as lodash from "lodash";

@Component({
    selector: "ng-app-list-top-exec",
    templateUrl: "./ng-app-list-top-exec.component.html",
    styleUrls: ["./ng-app-list-top-exec.component.less"]
})
export class NgAppListTopExecComponent implements OnInit, OnDestroy {
    topExecution: {
        type: string, appName: string,
        executionSuccessTotal: number, executionTotal: number, percentage?: number
    }[];
    barBackgroundColor = "#96A7F8";
    barChartBackgroundColor = "#F4F4F4";
    data: IMetricsTopExecutions[];
    barInputs: INgBarGraphValue[][] = [];
    appDetailsRoutes: { route: string[], queryParams: Object }[] = [];

    private subscriptions: Subscription[] = [];

    // Store pretty values
    formValues: string[] = [];

    constructor(private headerService: NgAppListHeaderService) {
        this.subscriptions.push(
            this.headerService.getTopExecutionsDataSubject()
                .subscribe(res => {
                    this.data = lodash.take(res, 5);
                    this.setFormValues();
                    this.setBarInputs();
                    this.setAppDetailsRoutes();
                })
        );
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.cleanSubscriptions();
    }

    onSelect(data): void {
        console.log("Item clicked", JSON.parse(JSON.stringify(data)));
    }

    private setFormValues() {
        this.formValues = this.data.map(d => displayBigNumber(d.count));
    }

    private cleanSubscriptions() {
        this.subscriptions.forEach(s => {
            try {
                s.unsubscribe();
            } catch (e) { }
        });
    }

    private setBarInputs() {
        this.barInputs = [];
        let max: number;
        for (let i = 0; i < this.data.length; i++) {
            if (i === 0) {
                max = this.data[i].count;
                this.barInputs.push([
                    { value: 0, bgColor: "#F4F4F4", label: null, unit: null },
                    { value: this.data[i].count, bgColor: "#96A7F8", label: null, unit: null },
                ]);
            } else {
                const perc = (this.data[i].count / max) * 100;
                this.barInputs.push([
                    { value: perc, bgColor: "#96A7F8", label: null, unit: null },
                    { value: 100 - perc, bgColor: "#F4F4F4", label: null, unit: null },
                ]);
            }
        }
    }

    private setAppDetailsRoutes() {
        this.appDetailsRoutes = this.data.map(d => getAppDetailsRoute(d.app));
    }

    onDeactivate(data): void {
        console.log("Deactivate", JSON.parse(JSON.stringify(data)));
    }
}
